export const INIT_INDEX = 0;
export const NO_INDEX = -1;
export const FIRST_PAGE = 1;
export const DEFAULT_MAX_PAGES = 10;
export const ONE_ELEMENT = 1;
export const IS_EMPTY = 0;
export const EMPTY_PAGE = 0;
export const BOOTSTRAP_TOTAL_COLUMNS = 12;
export const RESIZE_TIMEOUT = 200;
export const ZERO = 0;


export const QUERY_TRUE_VALUE = '1';
export const TRUE_VALUE = 1;
export const FALSE_VALUE = 0;
export const INFINITE_SCROLL_DISPATCH_TIMEOUT = 50;
export const INFINITE_SCROLL_PIXELS_TO_EDGE = 600;
export const DEFAULT_VALUE = 0;
export const DEFAULT_ARRAY = [];

export const POS_NEG_LINE = 0;
export const PERCENT = 100;
export const DOUBLE = 2;
export const RADIX_DECIMAL = 10;
export const DEFAULT_DECIMALS = 2;
const COMPUTE_INSTANCE = '1';
const RELATIONAL_DATABASE = '2';
const NOSQL_DATABASE = '3';
const INTERNET_CONNECTION = '4';

export const RESOURCE_TYPES = {
    COMPUTE_INSTANCE,
    RELATIONAL_DATABASE,
    NOSQL_DATABASE,
    INTERNET_CONNECTION
};

const PRIORITY_ISSUE_LOW = 'low';
const PRIORITY_ISSUE_MEDIUM = 'medium';
const PRIORITY_ISSUE_HIGH = 'high';

export const PRIORITY_ISSUE = {
    PRIORITY_ISSUE_LOW,
    PRIORITY_ISSUE_MEDIUM,
    PRIORITY_ISSUE_HIGH
};

const STATUS_ISSUE_CREATED = 'created';
const STATUS_ISSUE_SOLVED = 'solved';
const STATUS_ISSUE_PENDING = 'pending';

export const STATUS_ISSUE = {
    STATUS_ISSUE_CREATED,
    STATUS_ISSUE_SOLVED,
    STATUS_ISSUE_PENDING
};

const STATUS_RESOURCE_INSTANCE_WARNING = 1;
const STATUS_RESOURCE_INSTANCE_NORMAL = 2;

export const STATUS_RESOURCE_INSTANCE = {
    STATUS_RESOURCE_INSTANCE_WARNING,
    STATUS_RESOURCE_INSTANCE_NORMAL
};

const STATUS_RESERVATION_STOPPED = 0;
const STATUS_RESERVATION_ACTIVE = 1;

export const STATUS_RESERVATION = {
    STATUS_RESERVATION_STOPPED,
    STATUS_RESERVATION_ACTIVE
};

const MILISECONDS = 1000;
const MINUTES = 60;
const SECONDS = 60;
const HOURS = 24;

export const TIME = {
    MILISECONDS,
    MINUTES,
    SECONDS,
    HOURS

};

export const TIMEOUT = 2000;

export const PAGE_SIZE = 10;
export const PAGE_SIZE_MEDIUM = 8;
export const PAGE_SIZE_SMALL = 3;
export const PAGE_SIZE_LARGE = 20;
export const NUM_ITEMS_PAGINATION = 3;
export const DEFAULT_PAGE = 1;


const SORT_ASC = 1;
const SORT_DESC = -1;
const SORT_EQ = 0;

export const SORT = {
    SORT_ASC,
    SORT_DESC,
    SORT_EQ
};

export const TIMESTAMP_MULTIPLY = 1000;

const KEY_ESCAPE = 27;
const KEY_ENTER = 13;
const KEY_DELETE = 8;
const KEY_SUPR = 46;
const KEY_UP = 38;
const KEY_LEFT = 37;
const KEY_RIGHT = 39;
const KEY_DOWN = 40;
const KEY_TAB = 9;
const KEY_START = 36;
const KEY_END = 35;
const KEY_COLON = 188;
const KEY_DOT = 190;
const KEY_DOT_2 = 110;
const KEY_PAD_0 = 96;
const KEY_PAD_1 = 97;
const KEY_PAD_2 = 98;
const KEY_PAD_3 = 99;
const KEY_PAD_4 = 100;
const KEY_PAD_5 = 101;
const KEY_PAD_6 = 102;
const KEY_PAD_7 = 103;
const KEY_PAD_8 = 104;
const KEY_PAD_9 = 105;

export const KEYS = {
    KEY_ESCAPE,
    KEY_ENTER,
    KEY_DELETE,
    KEY_SUPR,
    KEY_UP,
    KEY_LEFT,
    KEY_RIGHT,
    KEY_DOWN,
    KEY_TAB,
    KEY_START,
    KEY_END,
    KEY_COLON,
    KEY_DOT,
    KEY_DOT_2,
    KEY_PAD_0,
    KEY_PAD_1,
    KEY_PAD_2,
    KEY_PAD_3,
    KEY_PAD_4,
    KEY_PAD_5,
    KEY_PAD_6,
    KEY_PAD_7,
    KEY_PAD_8,
    KEY_PAD_9
};

export const DEFAULT_SIZE_AVATAR = 64;

export const BEST_FIT_SECOND_VALUE_INDEX = 0;
export const BEST_FIT_SECOND_UNIT_INDEX = 1;
export const NUM_CHAR_TIME = 2;
export const SINGULAR_VALUE = 1;

const STATE_EXECUTION_QUEUED = '1';
const STATE_EXECUTION_LAUNCHED = '2';
const STATE_EXECUTION_SUCCESS = '3';
const STATE_EXECUTION_FAILED = '4';
const STATE_EXECUTION_UNKNOWN = '5';

export const STATE_EXECUTION = {
    STATE_EXECUTION_QUEUED,
    STATE_EXECUTION_LAUNCHED,
    STATE_EXECUTION_SUCCESS,
    STATE_EXECUTION_FAILED,
    STATE_EXECUTION_UNKNOWN
};

const BACKUP_STATUS_FAILED = 'FAILED';
const BACKUP_STATUS_START_FAILED = 'STARTFAILED';
const BACKUP_STATUS_KILLED = 'KILLED';
const BACKUP_STATUS_PARTIAL_SUCCESS = 'PARTIALSUCCESS';
const BACKUP_STATUS_SUCCESS = 'SUCCESS';
const BACKUP_STATUS_UNKNOWN = 'UNKNOWN';

export const BACKUP_STATUS = {
    BACKUP_STATUS_FAILED,
    BACKUP_STATUS_START_FAILED,
    BACKUP_STATUS_KILLED,
    BACKUP_STATUS_PARTIAL_SUCCESS,
    BACKUP_STATUS_SUCCESS,
    BACKUP_STATUS_UNKNOWN
};

export const HASH_SEED = 5;
export const NUM_COLORS = 10;
export const INIT_COLOR = 1;

export const AUTOCOMPLETE_DELAY = 500;
export const AUTOCOMPLETE_MIN_CHARS = 2;

const COLORS_BACKUPS_DAILY_OVERALL = 6;
const COLORS_BACKUPS_DAILY_PEAK = 2;
const COLORS_BACKUPS_DAILY_HOSTS = 0;
const COLORS_BACKUPS_TOP10 = 3;
const COLORS_BACKUPS_LAST13_BAR = 4;
const COLORS_BACKUPS_LAST13_AVG = 1;

export const COLORS_BACKUPS = {
    COLORS_BACKUPS_DAILY_OVERALL,
    COLORS_BACKUPS_DAILY_PEAK,
    COLORS_BACKUPS_DAILY_HOSTS,
    COLORS_BACKUPS_TOP10,
    COLORS_BACKUPS_LAST13_BAR,
    COLORS_BACKUPS_LAST13_AVG
};

const COLORS_STORAGE_ASSIGNED = 4;
const COLORS_STORAGE_USED = 6;
const COLORS_STORAGE_AVG = 2;

export const COLORS_STORAGE = {
    COLORS_STORAGE_ASSIGNED,
    COLORS_STORAGE_USED,
    COLORS_STORAGE_AVG
};

export const NAS = 2;
export const SAN = 1;
export const OS = 3;

const COLORS_CMDB_BACKUP = 4;
const COLORS_CMDB_NO_BACKUP = 6;
const COLORS_CMDB_WITHOUT_BACKUP = 2;

export const COLORS_CMDB = {
    COLORS_CMDB_BACKUP,
    COLORS_CMDB_NO_BACKUP,
    COLORS_CMDB_WITHOUT_BACKUP
};

export const CMDB_NO_EQX = 0;
export const CMDB_EQX = 1;
export const CMDB_ALL = 2;

export const NOTIFICATIONS_DAYS_SHOW = 2;

const TIMEOUT_STORE_BIG_SEED = 24; // 24 hours
const TIMEOUT_STORE_BIG = TIMEOUT_STORE_BIG_SEED * MINUTES * SECONDS * MILISECONDS;
const TIMEOUT_STORE_MEDIUM_SEED = 1; // 1 hour
const TIMEOUT_STORE_MEDIUM = TIMEOUT_STORE_MEDIUM_SEED * MINUTES * SECONDS * MILISECONDS;
const TIMEOUT_STORE_SMALL_SEED = 5; // Minutes
const TIMEOUT_STORE_SMALL = TIMEOUT_STORE_SMALL_SEED * SECONDS * MILISECONDS;

export const TIMEOUT_STORE = {
    TIMEOUT_STORE_BIG,
    TIMEOUT_STORE_MEDIUM,
    TIMEOUT_STORE_SMALL
};

export const SUBMIT_OPTIONS = {
    SAVE:             'save',
    SAVE_AND_STAY:    'saveAndStay',
    SAVE_ADD_ANOTHER: 'saveAddAnother',
    SAVE_AND_BACK:    'saveAndBack'
};

export const MENU_ITEMS = [
    SUBMIT_OPTIONS.SAVE,
    SUBMIT_OPTIONS.SAVE_ADD_ANOTHER,
    SUBMIT_OPTIONS.SAVE_AND_STAY];

export const EMPTY_CHART_MESSAGE_SIZE = {
    SMALL:  'small',
    MEDIUM: 'medium',
    LARGE:  'large'
};

export const FILTER_TYPES = {
    SEARCH:      'search',
    DROPWDOWN:   'dropdown',
    MULTISELECT: 'multiselect',
    DATETIME:    'datetime',
    SWITCH:      'switch', // Deprecated
    TOOGLE:      'toogle',
    CHECKBOX:    'checkbox'
};


const PARAM_TRUE = 1;
const PARAM_FALSE = 0;

export const PARAMS = {
    TRUE:  PARAM_TRUE,
    FALSE: PARAM_FALSE
};

const CATALOGS_ROOT_TYPE_ID = 0;
const CATALOG_TYPE_ID = 1;
const CATEGORY_TYPE_ID = 2;
const ITEM_TYPE_ID = 3;

export const REQUEST_CATALOG = {
    ROOT:     CATALOGS_ROOT_TYPE_ID,
    CATALOG:  CATALOG_TYPE_ID,
    CATEGORY: CATEGORY_TYPE_ID,
    ITEM:     ITEM_TYPE_ID
};

export const DEFAULT_BASELINE_SELECTED = 0;

const CALLER_ID = 'caller_id';
const COMPANY = 'company';
const DESCRIPTION = 'description';
const IMPACT = 'impact';
const SERVICE_OFFERING = 'service_offering';
const TITLE = 'short_description';
const WATCH_LIST = 'u_watch_list_new';
const URGENCY = 'urgency';
const TICKET_CUSTOMER = 'ticket_customer';

export const ERROR_KEYS_INCIDENTS = {
    CALLER_ID,
    COMPANY,
    DESCRIPTION,
    IMPACT,
    SERVICE_OFFERING,
    TITLE,
    TICKET_CUSTOMER,
    WATCH_LIST
};

export const ERROR_KEYS_REQUESTS = {
    CALLER_ID,
    COMPANY,
    DESCRIPTION,
    IMPACT,
    SERVICE_OFFERING,
    TITLE,
    WATCH_LIST,
    URGENCY,
    TICKET_CUSTOMER
};

const STATE_OPEN = 1;
const STATE_WORK_IN_PROGRESS = 2;
const STATE_AWAITING_PROBLEM = 3;
const STATE_PENDING = -5;
const STATE_PENDING_CUSTOMER = -2;
const STATE_RESOLVED = -3;
const STATE_CLOSED = 3;
const STATE_AWAITING_CHANGE = 10;
const STATE_CLOSED_CANCELLED = 4;

export const STATES = {
    OPEN:             STATE_OPEN,
    WORK_IN_PROGRESS: STATE_WORK_IN_PROGRESS,
    AWAITING_PROBLEM: STATE_AWAITING_PROBLEM,
    PENDING:          STATE_PENDING,
    PENDING_CUSTOMER: STATE_PENDING_CUSTOMER,
    RESOLVED:         STATE_RESOLVED,
    CLOSED:           STATE_CLOSED,
    AWAITING_CHANGE:  STATE_AWAITING_CHANGE,
    CLOSED_CANCELLED: STATE_CLOSED_CANCELLED
};

export const INFRASTRUCTURE_ACTIONS = {
    DISCOVER:     'discover',
    DOWNLOAD_CSV: 'download',
    START:        'start',
    STOP:         'stop'
};

const
    VALIDATION_STATE_SUCCESS = 1,
    VALIDATION_STATE_WARNING = 2,
    VALIDATION_STATE_ERROR = 3;

export const VALIDATION_STATE = {
    SUCCESS: VALIDATION_STATE_SUCCESS,
    WARNING: VALIDATION_STATE_WARNING,
    ERROR:   VALIDATION_STATE_ERROR
};


export const BILLING_ALERTS_STATES = {
    PENDING:  'PENDING',
    DISABLED: 'DISABLED',
    OK:       'OK',
    WARNING:  'WARNING',
    REACHED:  'REACHED'
};

export const BILLING_ALERTS_TYPES = {
    ACCOUNTS: 'ACCOUNTS',
    PROJECTS: 'PROJECTS',
    VENDORS:  'VENDORS'
};

export const AVAILABLE_CONTAINERS = {
    SERVICE_OFFERING:  'serviceOffering',
    SERVICE_NOW_USERS: 'serviceNowUsers',
    COMPANY:           'company',
    VENDORS:           'VENDORS',
    PROJECTS:          'PROJECTS',
    ACCOUNTS:          'ACCOUNTS'
};

export const FORMAT_DOLLARS = {
    style:                 'currency',
    currency:              'USD',
    maximumFractionDigits: DEFAULT_DECIMALS
};

export const FORMAT_MONTH_DATE = {
    year:  'numeric',
    month: 'long'
};

const STATUS_VM_ON = 1;
const STATUS_VM_OFF = 2;

export const STATUS_VM = {
    STATUS_VM_ON,
    STATUS_VM_OFF
};

export const ITEMS_PER_PAGE = [{
    id:   10,
    text: '10'
},
{
    id:   25,
    text: '25'
},
{
    id:   50,
    text: '50'
}];

export const INITIAL_FILTERS_STATE = {
    esxName:        '',
    vdcClient:      '',
    cluster:        '',
    vcenter:        '',
    searchField:    '',
    statusVm:       null,
    selectedFilter: 'None'
};

export const INITIAL_ARROWS_STATE = {
    statusVm: {
        upArrow:   'up-arrow',
        downArrow: 'down-arrow'
    },
    vmName: {
        upArrow:   'up-arrow',
        downArrow: 'down-arrow'
    },
    guestOs: {
        upArrow:   'up-arrow',
        downArrow: 'down-arrow'
    },
    cpuVm: {
        upArrow:   'up-arrow',
        downArrow: 'down-arrow'
    },
    ramVm: {
        upArrow:   'up-arrow',
        downArrow: 'down-arrow'
    },
    storageVm: {
        upArrow:   'up-arrow',
        downArrow: 'down-arrow'
    }
};



// WEBPACK FOOTER //
// ./src/util/constants.js